import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '@connect-x-app/hybrid-ui';
import { COLORS, PaperAirplane } from '@connect-x-app/shared-ui';
import { useInternetConnection } from '@connect-x-app/shared-utils';
import { Spinner } from '@connect-x-app/web-ui';

import './chatEmpty.scss';

type Props = {
  isLoading?: boolean;
};

export const ChatEmpty: FC<Props> = ({ isLoading }) => {
  const { t } = useTranslation();
  const { isInternetConnectionOnline } = useInternetConnection();

  return (
    <div className="empty-chat-container">
      {isLoading ? (
        <Spinner theme="normal" />
      ) : (
        <>
          <figure className="empty-chat-image">
            <img alt="empty-content" height={360} src={PaperAirplane} />
          </figure>
          <div className="empty-chat-text-container">
            <Text color={COLORS.zulu.$08} size="LG" uppercase weight="bold">
              {t(isInternetConnectionOnline ? 'CHAT.EMPTY_NO_MESSAGES' : 'OFFLINE.CHAT.EMPTY.TITLE')}
            </Text>
            <Text color={COLORS.zulu.$08} size="SM" weight="regular">
              {t(isInternetConnectionOnline ? 'CHAT.EMPTY_BREAK_ICE' : 'OFFLINE.CHAT.EMPTY.MESSAGE')}
            </Text>
          </div>
        </>
      )}
    </div>
  );
};
